import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAllClick, trackOfferClick, trackOffersShow } from './tracking';
import { selectOffersSuggestions } from '../../../common/selectors/offersSuggestions';
import { selectResultsJsonQuery } from '../../../common/selectors/results';
import { OffersSuggestionsLayout, OfferSuggestion } from '../../components/OffersSuggestions';

export const OffersSuggestionsContainer: React.FC = () => {
  const offersSuggestionsInfo = useSelector(selectOffersSuggestions);
  const jsonQuery = useSelector(selectResultsJsonQuery);

  const handleAllClick = React.useCallback(() => {
    if (!offersSuggestionsInfo || !offersSuggestionsInfo.items.length || !offersSuggestionsInfo.url) {
      return;
    }

    const products = offersSuggestionsInfo.items.map((item, index) => ({
      id: item.id,
      offerType: 'offer' as const,
      position: index + 1,
    }));

    trackAllClick(products, jsonQuery);
    window.location.href = offersSuggestionsInfo.url;
  }, [offersSuggestionsInfo, jsonQuery]);
  const handleShow = React.useCallback(() => {
    if (!offersSuggestionsInfo || !offersSuggestionsInfo.items.length) {
      return;
    }

    const products = offersSuggestionsInfo.items.map((item, index) => ({
      id: item.id,
      offerType: 'offer' as const,
      position: index + 1,
    }));

    trackOffersShow(products, jsonQuery);
  }, [offersSuggestionsInfo, jsonQuery]);

  if (!offersSuggestionsInfo || !offersSuggestionsInfo.items.length) {
    return null;
  }

  const { buttonTitle, items, subtitle, title } = offersSuggestionsInfo;

  return (
    <OffersSuggestionsLayout
      buttonTitle={buttonTitle || 'Все'}
      subtitle={subtitle || ''}
      title={title}
      onShow={handleShow}
      onAllClick={handleAllClick}
    >
      {items.map((item, index) => (
        <OfferSuggestion
          {...item}
          onClick={() => trackOfferClick(item.id, index + 1, jsonQuery)}
          key={`offer-suggestion-${item.id}`}
        />
      ))}
    </OffersSuggestionsLayout>
  );
};
